import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocaleImportsService } from './services/locale-imports/locale-imports.service';

@NgModule({
  imports: [CommonModule],
  providers: [LocaleImportsService]
})
export class FhProvidersModule {}
